import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  private verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private snackBar: MatSnackBar) { }

  /**
   * Este metodo envia un mensaje de alerta cuando una accion se realiza.
   * @param message que desea mostrar en pantalla.
   * @param action la accion que se tomara al presionar el boton de accion.
   */
  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      duration: 3500,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition
    });
  }

  openSnackBarCliente(message: string, action: string): void {
    this.snackBar.open(message, action, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition
    });
  }

  openSnackBarError(message: string, action: string): void {
    if (message !== '') {
      this.snackBar.open(message, action, {
        panelClass: ['snack-error']
      });
    } else {
      this.snackBar.dismiss();
    }
  }
  
  
}
